// **** import modules ****
import $ from "jquery";
import app, { u_, vuwer } from "@@assets/scripts/common";


// **** process ****
vuwer.add("downloadSection", {
	selector: "#download_section",
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		const $dataList = $("#data_list");
		this.setProp({ $dataList });
	},
	onChangeState(state) {
		if( Array.isArray(state.list) ) {
			this.renderList(state.list);
		}
	},
	renderList(list) {
		if( !Array.isArray(list) ) {
			throw new TypeError("arguments[0] must be array.");
		}
		
		console.log("renderList", { list });
		
		if( !this.$dataList ) {
			return this;
		}
		
		const { fileDir } = app.fm.config;
		
		$.fn.append.apply(
			this.$dataList.empty(),
			list.map(data => {
				const { name, file } = data;
				const $name = $("<span/>").addClass("icon-after").text(name);
				
				const pInfo = u_.pathInfo(file);
				switch(pInfo.extension) {
					case "pdf": {
						$name.attr("data-icon", "pdf");
						break;
					}
					
					case "doc":
					case "docx": {
						$name.attr("data-icon", "ms-doc");
						break;
					}
					
					case "xls":
					case "xlsx": {
						$name.attr("data-icon", "ms-xls");
						break;
					}
					
					case "ppt":
					case "pptx": {
						$name.attr("data-icon", "ms-ppt");
						break;
					}
				}
				
				const $file = $("<a/>").addClass("btn").attr({
					href: `${fileDir}/${file}`,
					download: `${name}.${pInfo.extension}`
				}).append(
					$("<span/>").text("ダウンロード")
				);
				
				return $("<li/>").append($name, $file);
			})
		);
		
		return this;
	}
});
